import { useMemo } from "react";

import { useGetSdlJson } from "../../components/hooks";
import { useTableContext } from "../providers";
import { IKeyStringAndValue } from "../types/Types";
//Special cases that uses values from diffrent keys in the same column
const useUpdateRowFargData = () => {
  const { listView } = useTableContext();
  const rowData = useGetSdlJson(listView).data?.farg;
  return useMemo(() => {
    if (rowData) {
      const updated = rowData.reduce(
        (acc: Array<IKeyStringAndValue>, cur: IKeyStringAndValue) => {
          const curCopy = { ...cur };
          curCopy.omraden = "Hela Sverige";

          if (parseInt(curCopy.alnarp) < 3) {
            curCopy.omraden = curCopy.omraden + "|" + "alnarp";
          }
          if (parseInt(curCopy.boras) < 3) {
            curCopy.omraden = curCopy.omraden + "|" + "boras";
          }
          if (parseInt(curCopy.uppsala) < 3) {
            curCopy.omraden = curCopy.omraden + "|" + "uppsala";
          }
          if (parseInt(curCopy.vindeln) < 3) {
            curCopy.omraden = curCopy.omraden + "|" + "vindeln";
          }
          acc.push(curCopy);
          return acc;
        },
        []
      );
      return updated;
    } else return [];
  }, [rowData]);
};

export default useUpdateRowFargData;
